// Third-party packages
import {
	EnumEnvironments,
} from '@enums/environments.enum';
import {
	Logger,
} from '@modules/logger';
import {
	PRIVATE_ROUTES_GLOBAL,
} from '@routes/lpdipro/private';
import {
	QueryClient,
	QueryClientProvider,
} from '@tanstack/react-query';
import {
	memo,
	useEffect,
} from 'react';
import {
	withTranslation,
} from 'react-i18next';
import {
	useDispatch,
	useSelector,
} from 'react-redux';
import {
	useLocation,
	useNavigate,
	useRoutes,
} from 'react-router-dom';

// Project modules
import {
	appSetRoute,
} from '@stores/_slices/app';
import {
	selectAppState,
} from '@stores/selectors/appSelectors';

const PrivateRoutes = () => {
	const queryClient = new QueryClient();
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const app = useSelector(selectAppState);

	useEffect(() => {
		Logger.getInstance({
			env: app.config?.STONAL_ENV as EnumEnvironments,
			SENTRY_DSN: app.config?.SENTRY_DSN_JS,
		});

		const currentFullPath = location.pathname + location.search;

		// check if a route has been stored from previous url before auth and is already the same as the current one
		if (app?.routes?.from && app.routes.from !== currentFullPath) {
			navigate(app.routes.from);
			dispatch(appSetRoute({
				name: 'from',
				url: null, // remove the value if the current one is the same to avoid recursive redirects
			}));
		} else if (app?.routes?.from) {
			dispatch(appSetRoute({
				name: 'from',
				url: null,
			}));
		}
	}, []);

	return (
		<QueryClientProvider client={queryClient}>
			{useRoutes(PRIVATE_ROUTES_GLOBAL)}
		</QueryClientProvider>
	);
};

export const AppPrivate = memo(withTranslation()(PrivateRoutes));
